import { media, COLOURS, BORDER_RADIUS } from '@belong/themes';
import styled from 'styled-components';

export const CalloutWrapper = styled.div`
  display: flex;

  :not(:last-child) {
    margin-bottom: 1.6rem;
  }
`;

export const OfferAlertWrapperPlain = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.2rem;
  
  ${media('xl')`
    justify-content: flex-start;
  `}
}
`;

export const OfferAlertWrapper = styled.div`
  border-radius: ${BORDER_RADIUS.CARD};
  background-color: ${COLOURS.GREY_100};
  padding: 1.2rem;

  ${media('lg')`
    padding: 1.6rem;
  `}
`;
